// extracted by mini-css-extract-plugin
export var active = "_jf-e";
export var blink = "_jf-f";
export var dropDownSelector = "_jf-5";
export var dropDownWrapper = "_jf-4";
export var fakeCursor = "_jf-d";
export var fontSizeButton = "_jf-7";
export var formQuillEditor = "_jf-0";
export var pressed = "_jf-g";
export var qlBlank = "_jf-1";
export var textFormattingToolbar = "_jf-2";
export var textFormattingToolbarClosed = "_jf-3";
export var textFormattingToolbarInline = "_jf-6";
export var textToolbarOption = "_jf-8";
export var toolbarCell = "_jf-a";
export var toolbarCellCollapsed = "_jf-b";
export var toolbarOptionHitArea = "_jf-c";
export var toolbarOverflow = "_jf-9";